import React from 'react';

/** The green band at the top of every page: title, a one-line summary, the page's actions. */
const PageHeader = ({ title, subtitle, children, below }) => (
    <header className="page-head">
        <div className="flex flex-wrap items-end justify-between gap-3">
            <div className="min-w-0">
                <h1 className="page-title">{title}</h1>
                {subtitle && <p className="page-sub">{subtitle}</p>}
            </div>
            {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
        </div>
        {below}
    </header>
);

export default PageHeader;
